import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { FlexBenefitActivationDialogExtension } from './extension/flex-benefit-activation-dialog.extension';
import { FlexBenefitColumnsExtension } from './extension/flex-benefit-columns.extension';
import { FlexBenefitInfoTextExtension } from './extension/flex-benefit-info-text.extension';
import { FlexBenefitMetadataExtension } from './extension/flex-benefit-metadata.extension';
import { FlexBenefitNavigationExtension } from './extension/flex-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('flex')
    .add(BenefitMetadataExtensionInterface, new FlexBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new FlexBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new FlexBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new FlexBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new FlexBenefitInfoTextExtension())
    .build(),
);
